import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';
import { actions as localeActions } from '../../../redux/ui/locale';
import { isLoggedUserSelector } from '../../../redux/context/selectors';

import styles from '../index.styl';

const mapStateToProps = state => ({
  isLoggedUser: isLoggedUserSelector(state),
});

const mapDispatchToProps = {
  setLanguage: localeActions.setLocale,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/LanguagePicker/enhance.js